import { useStore } from "@/stores/useStore";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/Base/Select";
import { Fragment, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CardConfigPage from "./CardConfig.page";
import CompanyInfoPage from "./CompanyInfo.page";
import EmployeesPage from "./Employees.page";
import IntegrationsPage from "./Integrations.page";
import LayoutBuilderPage from "./LayoutBuilder.page";
import ShopDashboardPage from "./ShopDashboard.page";
import TermsAndConditionsPage from "./TermsAndConditions.page";
import { ActivityFeedPage } from "./ActivityFeed.page";
import { AutomationsPage } from "./Automations.page";
import MetricsPage from "./Metrics.page";
import { Loading } from "@/components/Page/Loading";
import { NotAssociatedView } from "@/components/Onboarding/NotAssociatedView";

export const DashboardPage = () => {
  const navigate = useNavigate();
  const shopId = useStore((s) => s.shopId);
  const { user, allowedShops } = useStore((s) => s);
  const setCurrentShopId = useStore((s) => s.setCurrentShopId);

  const handleShopChange = (shopId: string) => {
    setCurrentShopId(shopId);
  };

  useEffect(() => {
    if (!shopId && allowedShops.length === 1) {
      setCurrentShopId(allowedShops[0].id);
    }
  }, [setCurrentShopId, allowedShops, shopId]);

  useEffect(() => {
    if (shopId) {
      navigate(`/${shopId}`);
    }
  }, [shopId, navigate]);

  const handleClickCreateShop = () => {
    navigate("/create-shop");
  };

  if (!allowedShops || !user) {
    return <Loading />;
  }

  return (
    <div className="mx-auto flex max-w-screen-md flex-col gap-2">
      <div className="mt-4">
        {allowedShops?.length > 0 ? (
          <Fragment>
            <h1 className="text-3xl">Welcome {user && user.displayName}</h1>
            <p className="mt-2">Select a shop to view your dashboard.</p>
            <div className="mr-4 mt-5 w-full">
              <p>Active Shop:</p>
              <Select onValueChange={handleShopChange} name="shopId">
                <SelectTrigger className="w-48">
                  <SelectValue placeholder="Select a Shop" />
                </SelectTrigger>
                <SelectContent>
                  {allowedShops
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((s) => (
                      <SelectItem key={s.id} value={`${s.id}`}>
                        {s.name}
                      </SelectItem>
                    ))}
                </SelectContent>
              </Select>
            </div>
          </Fragment>
        ) : (
          <NotAssociatedView onClick={handleClickCreateShop} />
        )}
      </div>
    </div>
  );
};

export {
  ActivityFeedPage,
  AutomationsPage,
  CardConfigPage,
  CompanyInfoPage,
  EmployeesPage,
  IntegrationsPage,
  LayoutBuilderPage,
  MetricsPage,
  ShopDashboardPage,
  TermsAndConditionsPage,
};
